import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./TextoNosotros.css";
import nosotrosjynperez1 from "../../assets/images/nosotros-jynperez1.png";
import nosotrosjynperez2 from "../../assets/images/nosotros-jynperez2.png";



const TextoNosotros = () => {
  return (
    <div className="parrafos-imagenes-section">
      <Container>
        <Row className="mb-lg-5 mb-md-3 mb-sm-4 mb-3 justify-content-center">
          <Col md={10} lg={6} className="text-left mt-5">
            <h5 className="parrafos-subtitle">J y N PEREZ | INDUSTRIA METALÚRGICA</h5>
            <h2 className="parrafos-title">Nuestra Historia Y Legado</h2>
            <p className="parrafos-text">
              Metalúrgica J y N Perez nace de la dedicación y el compromiso de Juan Carlos Pérez y
              Néstor F. Pérez, quienes, tras años de experiencia (1978 a 1989) bajo la guía de los
              hermanos Humberto y Enrique Bellini, se iniciaron como los nuevos propietarios de la
              empresa, manteniendo la esencia y valores que la caracterizaron desde sus inicios.
              Nuestra historia es un testimonio de la confianza y la estrecha relación construida a
              lo largo de los años, que nos ha permitido evolucionar sin perder nuestra identidad.
            </p>
          </Col>
          <Col md={10} lg={6} className="p-md-5 p-lg-5">
            <img
              src={nosotrosjynperez1}
              alt="Historia y Legado"
              className="parrafos-image"
            />
          </Col>
        </Row>

        <Row className="mb-5 justify-content-center reverse-img">
          <Col md={10} lg={6} className="order-md-2 text-left mt-5">
            <h5 className="parrafos-subtitle">ACERCA DE NOSOTROS</h5>
            <h2 className="parrafos-title">Calidad Y Compromiso Familiar</h2>
            <p className="parrafos-text">
              Somos una empresa familiar con una sólida trayectoria en la industria metalúrgica,
              especializada en la fabricación y comercialización de artículos gastronómicos
              elaborados en alambre y tejido. Con años de experiencia, nos dedicamos al diseño y
              producción de soluciones personalizadas que satisfacen las necesidades específicas
              del sector gastronómico. Nuestra principal fortaleza radica en la alta calidad de
              nuestros productos y en nuestro firme compromiso con cada cliente. Nos destacamos
              por nuestra capacidad para ofrecer respuestas rápidas y eficaces, tanto en la creación
              de nuevos productos como en la puntualidad de nuestras entregas. En todo momento,
              nos aseguramos de respetar y escuchar las demandas de nuestros clientes, lo que nos
              convierte en una empresa confiable y comprometida.
            </p>
          </Col>
          <Col md={10} lg={6} className="order-md-1 p-md-5 p-lg-5">
            <img
              src={nosotrosjynperez2}
              alt="Calidad y Compromiso Familiar"
              className="parrafos-image"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TextoNosotros;
